import React from 'react';
import { Modal, ModalHeader, ModalFooter, Button, ModalBody, ListGroup, ListGroupItem } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { useComponentsContext } from '../../../ParamComponents';
import { ComponentService, KomponentenTypUtil } from '../../../../api';
import { ComponentReleasesDto } from '../../../../api/dto';
import { isServiceError } from '../../../../api/errors';

export interface ReleasesModalProps {
  open: boolean;
  setOpen: Function;
  items: any[];
  type: string;
}

/**
 * modal to confirm releases of components 
 * @param param0 
 */
export const ReleasesModal: React.FC<ReleasesModalProps> = ({ open, setOpen, items, type }): JSX.Element | null => {
  const { setMessage, filter, setFilter } = useComponentsContext();

  const handleClickAccept = async (): Promise<void> => {
    setOpen(false);
    console.log('Element', type, items);

    const dto: ComponentReleasesDto = {type: type, 
      releases: items.map((e) => {
        return {id: e.id};
      })
    };
    try{
      const kompTyp = KomponentenTypUtil.getComponentName(KomponentenTypUtil.getComponentTypeEnum(type));
      const result = await ComponentService.releaseComponent(dto);
      console.log('release-result', kompTyp, result);
      if(result) {
        result.releases.forEach((r) => {
          const comp = items.find((e => { if (Number(e.id) === Number(r.id)) { return e}}));
          if(r.result === 'OK') {
            setMessage({id: undefined, color: "success", messageId: 'component_release_success', messageValues: {component: kompTyp, name: comp.name }});
          } else {
            setMessage({id: undefined, color: "danger", messageId: 'component_release_error', messageValues: {component: kompTyp, name: comp.name }});    
          }
        });
        // update filter to reload data of table
        setFilter(filter ? {...filter} : undefined);
      } else {
        console.log('release-result-error');
        setMessage({id: undefined, color: "danger", messageId: 'component_release_error_general', messageValues: { details: '' }});
      }
    } catch(e) {
      console.log('release-result-catch',e);
      if(isServiceError(e)) {
        setMessage({id: undefined, color: "danger", messageId: 'component_release_error_general', messageValues: { details: e.response.message }});

      }
    }
  }

  const handleClickCancel = (): void => {
    setOpen(false);
  }

  return (
    <React.Fragment>
      <Modal isOpen={open} toggle={() => {setOpen(!open)}}>
        <ModalHeader>
          <FormattedMessage id="modal_header_release" />
        </ModalHeader>
        <ModalBody>
          <p>Möchten Sie folgende Komponente(n) freigeben?</p>
          <ListGroup>
            {items.map(e => {
              return <ListGroupItem key={e.code}>{e.name}</ListGroupItem>
            })}
          </ListGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={handleClickCancel} >
            <FormattedMessage id="button_cancel"/>
          </Button>
          <Button 
            color="primary" 
            onClick={handleClickAccept} >
            <FormattedMessage id="button_confirm"/>
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );

}
